import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DynamicSeriesReducer, IDynamicYear } from 'types/mainPage';

const initialState: DynamicSeriesReducer = {
  dynamicYears: [],
  isOpen: false,
};

export const dynamicSeriesSlice = createSlice({
  initialState,
  name: 'measurements',
  reducers: {
    setDynamicYears(state, action: PayloadAction<IDynamicYear[]>) {
      state.dynamicYears = action.payload;
    },
    toggleOpen(state) {
      state.isOpen = !state.isOpen;
    },
    resetDynamicYears(state) {
      state.dynamicYears = [];
      state.isOpen = false;
    },
  },
});

export default dynamicSeriesSlice.reducer;
